// src/modules/dashboard/routes.js
// The legacy role-switch dashboard has been retired. Dashboards are now built per
// role permission set in the Dashboard Builder and rendered by
// modules/moduleDashboards/pages/ModuleDashboardPage — so /dashboard just
// forwards there, keeping every old link and post-login redirect working.
import { Routes, Route, Navigate } from 'react-router-dom';

const DashboardRoutes = () => (
  <Routes>
    <Route path="*" element={<Navigate to="/module-dashboards" replace />} />
  </Routes>
);

export default DashboardRoutes;
